module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-preset-react-app/node_modules/babel-runtime/regenerator/index.js
// module id = 4
// module chunks = 58